<div class="data-section">
  <div class="data-section-heading">{{ 'surgical_qa_panel.patient_treatments' | translate }}</div>
  @for (patientTreatmentForReview of patientTreatmentsForReview; track patientTreatmentForReview; let isLast = $last) {
  <div>
    <stx-historic-treatment-detail-row [patientTreatmentForReview]="patientTreatmentForReview"></stx-historic-treatment-detail-row>
    @if (!isLast) {
    <hr class="form-subsection-separator" />
    }
  </div>
  }
</div>
